<div class="rds-c-measure-select-container">
  <mat-icon
    aria-hidden="false"
    class="rds-c-selection-info-icon"
    [mtnaPopover]="config"
    [mtnaClosePopoverAriaLabel]="selectLabel | rdsPopoverAriaLabel: false"
    [mtnaOpenPopoverAriaLabel]="selectLabel | rdsPopoverAriaLabel: true"
    >info</mat-icon
  >
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{ selectLabel }}</mat-label>
    <mat-select
      [disabled]="disabled"
      [errorStateMatcher]="$any(_matcher)"
      [required]="required"
      [placeholder]="selectPlaceholder"
      [value]="value?.length === 1 ? value[0].measureType : null"
    >
      <mat-option
        *ngFor="let type of types"
        (click)="_handleOptionSelectionChange(type)"
        (keydown.enter)="_handleOptionSelectionChange(type)"
        [value]="type"
        >{{ _measureOptions[type].label }}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="!value?.length" align="end" i18n>The default is count</mat-hint>
    <mat-error align="end">
      <span *ngFor="let error of $any(_control?.errors) | keyvalue" [ngSwitch]="error.key">
        <ng-template ngSwitchCase="required" i18n>This field is <strong>required</strong></ng-template>
        <ng-template ngSwitchDefault>{{ error.value }}</ng-template>
      </span>
    </mat-error>
    <mat-icon *ngIf="suffixIcon" matSuffix>{{ suffixIcon }}</mat-icon>

    <rds-c-chips
      *ngIf="!!value?.length && _measureOptions[value[0].measureType].requiresVariable"
      [chips]="[value[0].variable | rdsVariableToChip]"
      [selectable]="false"
      [vertical]="true"
      (removed)="_emitChangeEvent(null)"
    ></rds-c-chips>
  </mat-form-field>
</div>
